import { useState, useEffect, useMemo } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { useUser } from "../utils/UserContext";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretDown, faChartSimple, faFileLines, faCaretUp, faStar, faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import TradingViewWidget from "../components/TradingViewWidget";
import FuturesTradeForm from "../components/FuturesTradeForm";
import OpenFutures from "../components/OpenFutures";
import PositionMobile from "../components/PositionMobile";
import PositionFutures from "../components/PositionFutures";
import CopyFutures from "../components/CopyFutures";
import FutureHistory from "../components/FutureHistory";
import OrderBook from "../components/OrderBook";
import { useLocation } from "react-router-dom";
import { toast } from 'react-hot-toast';
import Ticker2 from "../components/Ticker2";
import { formatCurrency } from '../utils/currencyUtils';

function Futures() {
  const { user } = useUser();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const symbol = queryParams.get("symbol");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [type, setType] = useState('crypto');
  const [trade, setTrade] = useState(symbol ? symbol : type === "crypto" ? "BTC" : type === "forex" ? "AAPL" : "EUR");
  const [activeTab, setActiveTab] = useState("position")
  const [futureasset, setFutureasset] = useState([])
  const [tradeTab, setTradeTab] = useState('form')
  const [openTrades, setOpenTrades] = useState([]);
  const [orderHistory, setOrderHistory] = useState([]);  
  const [positionTrades, setPositionTrades] = useState([]); 
  const [copyTrades, setCopyTrades] = useState([]); 
  const [pageLoading, setPageLoading] = useState(true);
  //WALET CARD
  const [crypto, setCrypto] = useState([]);
  const [wallet, setWallet] = useState(null);
  const [assethistory, setAssethistory] = useState([]);
  useEffect(() => {
    if (!user?.id) return;
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchwallet: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setWallet(data.wallet || []);
      }
    })
    .catch(err => {
    })
  }, [user?.id]);
  useEffect(() => {
    fetch(`/coin_list.txt`)
    .then((res) => res.json())
    .then((data) => {
    var coinList = data.data.sort((a, b) => a.name.localeCompare(b.name));
    const updatedData = coinList.map((coin, index) => {
      const walletItem = wallet.find(item => item.coinName === coin.name);
      return {
        id: index + 1,
        label: <><img src={`https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`} alt={coin.symbol} width="20" /> {coin.symbol}</>,
        logo: `https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`,
        coin_id: coin.id,
        name: coin.name,
        symbol: coin.symbol,
        price: Number(coin.quote.USD.price),
        percentage: Number(coin.quote.USD.percent_change_24h.toFixed(2)),
        value: coin.symbol,
        balance: walletItem ? walletItem.balance : 0,
      };
    });
    setCrypto(updatedData);
    })
    .catch((err) => console.error("Error loading coin list:", err));
  }, [wallet]);
  useEffect(() => {
    if (!crypto.length) return;
    let total = 0;
    const applyWalletBalance = (list) =>
      list.map(item => {
        const value = item.price;
        total += value;
        return {
          ...item,
          amount: 0
        };
      });
    const merged = [
      ...applyWalletBalance(crypto),
    ];
    const sorted = merged.sort((a, b) => {
      return a.name.localeCompare(b.name);
    });
    setAssethistory(sorted);
  }, [crypto]);
  useEffect(() => {
    const fetchTrades = () => {
      fetch(`${process.env.REACT_APP_API_URL}controller/futures.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          fetchfuturestrade: true
        })
      })
        .then(response => response.json())
        .then(data => {
          if (data.status === "success" && data.trades) {
            const openTrades = [];
            const positionTrades = [];
            const orderHistory = [];
            data.trades.forEach(trade => {
              if (trade.status === "open") {
                openTrades.push(trade);
              } else if (trade.status === "position") {
                positionTrades.push(trade);
              } else {
                orderHistory.push(trade);
              }
            });
            setOpenTrades(openTrades);
            setPositionTrades(positionTrades);
            setOrderHistory(orderHistory);
          }
        })
        .catch(error => {
          console.error("Failed to fetch futures trades:", error);
        });
    };
    fetchTrades();
    const interval = setInterval(fetchTrades, 3000);
    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/futures.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchCopytrade: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setCopyTrades(data.trades);
      }else{
        toast.error(data.message);
      }
    })
    .catch(err => {
    })
  }, [user]);    
  const [coinListModal, setCoinListModal] = useState(false);
  const [coinListSearch, setCoinListSearch] = useState('');
  function filterCoinList(search){
    setCoinListSearch(search);
  }
  const filteredCoinList = useMemo(() => {
    const q = coinListSearch.trim().toLowerCase();
    if (!q) return crypto;
    return crypto.filter(
      c =>
        c.name.toLowerCase().includes(q) ||
        c.symbol.toLowerCase().includes(q)
    );
  }, [coinListSearch, crypto]);
  useEffect(() => {
    const futureasset = assethistory.find(item => item.symbol == trade)
    setFutureasset(futureasset)
  }, [trade, assethistory]);
  useEffect(() => {
    const everythingLoaded =
      user?.id &&
      wallet !== null &&
      crypto.length > 0 &&
      assethistory.length > 0 &&
      futureasset;
    if (everythingLoaded) {
      const timer = setTimeout(() => {
        setPageLoading(false);
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [
    user?.id,
    wallet,
    crypto,
    assethistory,
    futureasset,
    openTrades,
    positionTrades,
    orderHistory,
    copyTrades
  ]);
  if (pageLoading) {
    return <div style={{ textAlign: "center", marginTop: "20%", marginBottom: "20%"}}><FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '30px', color: '#ff6b35', opacity: '0.5'}} spin /></div>;
  }
  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Futures" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Futures" icon={<FontAwesomeIcon icon={faChartSimple} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <div className="row">
              <div className="col-12">
                <div className="mt-2">
                    <Ticker2 crypto={crypto} pauseOnHover />
                </div>
              </div>
              <div className="col-12">
                <div className="d-flex align-items-center justify-content-between mt-2">
                  {futureasset && (
                  <div className="d-flex align-items-center" onClick={() => setCoinListModal(!coinListModal)}>
                    <img src={futureasset.logo} alt={futureasset.symbol} width="30"/>
                    <div className="ms-2">
                      <p className="mb-0 fw-bold fs-5" style={{lineHeight:'120%'}}>{futureasset.symbol}USDT <FontAwesomeIcon icon={coinListModal ? faCaretUp : faCaretDown}className="ms-2" style={{fontSize: '14px'}} /></p>
                      <p className={`mb-0 ${futureasset.percentage > 0 ? 'text-success' : 'text-danger'} fw-semibold lh-1`}>{futureasset.percentage}%</p>
                    </div>
                  </div>
                  )}
                  <div className={`coinList position-absolute p-3 rounded-3 d-flex flex-column ${coinListModal ? 'active' : null}`} style={{backgroundColor:'#101113ff',zIndex:'10'}}>
                    <div className="form-control justify-content-between py-1 pe-1">
                      <input 
                          type="search" 
                          placeholder="Search Coin"
                          className="inputNone w-100"
                          value={coinListSearch}
                          onChange={(e) => { filterCoinList(e.target.value); }}
                      />
                    </div>
                    <div className="mt-2 coinListAll">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <div style={{width:'60%'}}>
                          <p className="mb-0" style={{fontSize:'14px'}}>PAIR</p>
                        </div>
                        <div style={{width:'40%'}}>
                          <p className="mb-0 text-end" style={{fontSize:'14px'}}>PRICE</p>
                        </div>
                        <div style={{width:'40%'}}>
                          <p className="mb-0 text-end" style={{fontSize:'14px'}}>CHANGE</p>
                        </div>
                      </div>
                      {filteredCoinList.length > 0 && filteredCoinList.map((coin, index) => {
                        if(coin.symbol != "USDT"){
                        return (
                        <div onClick={() => {setTrade(coin.symbol);setCoinListModal(false);}} key={index} className="d-flex align-items-center justify-content-between mb-2" style={{cursor:'pointer'}}>
                          <div style={{width:'60%'}}>
                            <div className="d-flex align-items-center">
                              <img src={coin.logo} alt="BTC" width="20" />
                              <p className="mb-0 ms-1" style={{fontWeight:'900',fontSize:'14px'}}>{coin.symbol}</p>
                              <p className="mb-0" style={{fontSize:'11px'}}>/USDT</p>
                            </div>
                            <div className="d-flex align-items-center">
                              <FontAwesomeIcon icon={faStar} className="text-warning ms-1" style={{fontSize: '10px'}} />
                              <p className="mb-0 ms-1" style={{fontSize:'12px'}}>{Number(coin.balance).toFixed(4)}</p>
                            </div>
                          </div>
                          <div style={{width:'40%'}}>
                            <div className="text-end">
                              <p className="mb-0" style={{fontSize:'14px',fontWeight:'900'}}>{Number(coin.price).toFixed(7)}</p>
                              <p className="mb-0" style={{fontSize:'12px'}}>= {formatCurrency(coin.price)} USD</p>
                            </div>
                          </div>
                          <div style={{width:'40%'}}>
                            <p className="text-end mb-0">
                              <div className={`d-inline-block py-1 px-2 ${coin.percentage > 0 ? 'bg-success' : 'bg-danger'}`} style={{fontSize:'14px',fontWeight:'900',minWidth:'65px'}}>{coin.percentage.toFixed(2)}%</div>
                            </p>
                          </div>
                        </div>
                        );
                      }})}
                      {filteredCoinList.length === 0 && (
                        <p className="mb-0 text-center">No item found</p>
                      )}
                    </div>
                  </div>
                  <div className="pillTab d-lg-none">
                    <div className={`Tabin ${tradeTab == 'chart' ? 'active' : null}`} onClick={() => setTradeTab('chart')}>
                      <FontAwesomeIcon icon={faChartSimple} style={{fontSize: '16px'}} />
                    </div>
                    <div className={`Tabin ${tradeTab == 'form' ? 'active' : null}`} onClick={() => setTradeTab('form')}>
                      <FontAwesomeIcon icon={faFileLines} style={{fontSize: '16px'}} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xxl-2 col-lg-3 col-5 pe-0">
                {futureasset && (
                  <OrderBook futureasset={futureasset}/>
                )}
              </div>
              <div className={`col-xxl-7 col-lg-6 col-md-6 col-12 d-lg-block ${tradeTab == 'chart' ? 'd-block' : 'd-none'}`}>
                <div className="mycard p-2 mt-2">
                  {futureasset && (
                  <div className="d-flex justify-content-between mb-2 mt-1">
                    <div>
                      <p className="mb-0 lh-1 text-secondary fw-semibold" style={{fontSize:'12px'}}>Last traded Price</p>
                      <p className={`fs-3 mb-0 ${futureasset.percentage > 0 ? 'text-success' : 'text-danger'}`} style={{lineHeight:'120%', fontWeight:'900'}}>{formatCurrency(futureasset.price)}</p>
                      <p className="mb-0 lh-1 text-secondary fw-semibold" style={{fontSize:'12px'}}>Mark Price {formatCurrency(Number(futureasset.price) - (Number(futureasset.percentage) / 100) * Number(futureasset.price))}</p>
                    </div>
                    <div style={{minWidth:'120px'}}>
                      <div className="d-flex align-items-center justify-content-between">
                        <p className="mb-0 text-secondary fw-semibold" style={{fontSize:'12px'}}>24h High</p>
                        <p className="mb-0 fw-semibold" style={{fontSize:'12px'}}>{formatCurrency(Number(futureasset.price) + (Number(futureasset.percentage) / 100) * Number(futureasset.price))}</p>
                      </div>
                      <div className="d-flex align-items-center justify-content-between">
                        <p className="mb-0 text-secondary fw-semibold" style={{fontSize:'12px'}}>24h Low</p>
                        <p className="mb-0 fw-semibold" style={{fontSize:'12px'}}>{formatCurrency(Number(futureasset.price) - (Number(futureasset.percentage) / 100) * Number(futureasset.price))}</p>
                      </div>
                    </div>
                  </div>
                  )}
                  <TradingViewWidget height="600" symbol={trade} type={type} />
                </div>
              </div>
              <div className={`col-lg-3 col-7 ps-0 d-lg-block ${tradeTab === 'form' ? 'd-block' : 'd-none'}`}>
                <FuturesTradeForm trade={trade} setTrade={setTrade} type={type} setType={setType}/>
              </div>
              <div className="col-12">
                <div className="mycard mt-2" style={{minHeight: '450px'}}>
                  <div className="d-flex flex-wrap align-items-center mb-4">
                    <h6 className="mb-2 text-white me-3" style={{fontSize: '18px'}}>Futures Trades</h6>
                    <div className="mytab flex-wrap">
                      <div className={`mytab-item ${activeTab === "position" ? 'active' : ''}`} onClick={() => {
                        setActiveTab("position")}}>Positions ({positionTrades.length})</div>
                      <div className={`mytab-item ${activeTab === "open" ? 'active' : ''}`} onClick={() => {
                        setActiveTab("open")}}>Open Orders ({openTrades.length})</div>
                      <div className={`mytab-item ${activeTab === "history" ? 'active' : ''}`} onClick={() => {
                        setActiveTab("history")}}>Order History</div>
                      <div className={`mytab-item ${activeTab === "copy" ? 'active' : ''}`} onClick={() => {
                        setActiveTab("copy")}}>Copy Trades</div>
                    </div>
                  </div>
                  <div className="table-responsive">
                    {activeTab === "position" && (
                    <>
                      <table className="table table-borderless table-dark align-middle d-none d-lg-table">
                        <thead>
                          <tr className="fs-7">
                            <th className="fw-normal text-light">SN</th>
                            <th className="fw-normal text-light text-nowrap">Trading ID</th>
                            <th className="fw-normal text-light">Type</th>
                            <th className="fw-normal text-light">Direction</th>
                            <th className="fw-normal text-light">Pattern</th>
                            <th className="fw-normal text-light">Leverage</th>
                            <th className="fw-normal text-light">Coin</th>
                            <th className="fw-normal text-light text-nowrap">Entry Price</th>
                            <th className="fw-normal text-light">Margin</th>
                            <th className="fw-normal text-light">Qty</th>
                            <th className="fw-normal text-light text-nowrap">Market Price</th>
                            <th className="fw-normal text-light text-nowrap">Liq. Price</th>
                            <th className="fw-normal text-light text-nowrap">Unrealized P&L(ROI)</th>
                            <th className="fw-normal text-light">TP/SL</th>
                            <th className="fw-normal text-light text-nowrap">Time Created</th>
                            <th className="fw-normal text-light">Action</th>
                          </tr>
                        </thead>
                        <tbody style={{fontSize: '14px'}}>
                          {positionTrades.length > 0 && positionTrades.map((trade, index) => {
                            // PUT THE CODE HERE - inside the map function
                            const baseCoin = trade.coin_id;
                            const tradeasset = assethistory.find(item => item.coin_id == baseCoin);
                            return (
                              <PositionFutures index={index} tradeasset={tradeasset} trade={trade} />
                            );
                          })}
                          {positionTrades.length === 0 && (
                            <tr>
                              <td colSpan={5}>No open position.</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                      <div className="d-block d-lg-none">
                      {positionTrades.length > 0 && positionTrades.map((trade, index) => {
                        // PUT THE CODE HERE - inside the map function
                        const baseCoin = trade.coin_id;
                        const tradeasset = assethistory.find(item => item.coin_id == baseCoin);
                        return (
                          <PositionMobile index={index} tradeasset={tradeasset} trade={trade} />
                        );
                      })}
                      <hr className="mt-2 mb-0"/>
                      </div>
                    </>
                    )}
                    {activeTab === "open" && (
                    <table className="table table-borderless table-dark align-middle">
                      <thead>
                        <tr className="fs-7">
                          <th className="fw-normal text-light">SN</th>
                          <th className="fw-normal text-light text-nowrap d-lg-table-cell d-none">Trading ID</th>
                          <th className="fw-normal text-light d-md-table-cell d-none">Type</th>
                          <th className="fw-normal text-light d-md-table-cell d-none">Direction</th>
                          <th className="fw-normal text-light d-md-table-cell d-nones">Pattern</th>
                          <th className="fw-normal text-light d-md-table-cell d-none">Leverage</th>
                          <th className="fw-normal text-light">Coin</th>
                          <th className="fw-normal text-light text-nowrap d-lg-table-cell d-none">Entry Price</th>
                          <th className="fw-normal text-light text-nowrap">Margin</th>
                          <th className="fw-normal text-light d-lg-table-cell d-none">Qty</th>
                          <th className="fw-normal text-light d-lg-table-cell d-none">TP/SL</th>
                          <th className="fw-normal text-light text-nowrap d-lg-table-cell d-none">Time Created</th>
                          <th className="fw-normal text-light d-lg-table-cell d-none">Action</th>
                          <th className="fw-normal text-light d-lg-none"></th>
                        </tr>
                      </thead>
                      <tbody style={{fontSize: '14px'}}>
                        {openTrades.length > 0 && openTrades.map((trade, index) => {
                          // PUT THE CODE HERE - inside the map function
                          const baseCoin = trade.coin_id;
                          const tradeasset = assethistory.find(item => item.coin_id == baseCoin);
                          return (
                            <OpenFutures index={index} tradeasset={tradeasset} trade={trade} />
                          );
                        })}
                        {openTrades.length === 0 && (
                          <tr>
                            <td colSpan={5}>No open trades yet.</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                    )}
                    {activeTab === "history"  && (
                    <table className="table table-borderless table-dark align-middle">
                      <thead>
                        <tr className="fs-7">
                          <th className="fw-normal text-light">SN</th>
                          <th className="fw-normal text-light text-nowrap d-lg-table-cell d-none">Trading ID</th>
                          <th className="fw-normal text-light d-md-table-cell d-none">Type</th>
                          <th className="fw-normal text-light d-md-table-cell d-none">Direction</th>
                          <th className="fw-normal text-light d-md-table-cell d-none">Pattern</th>
                          <th className="fw-normal text-light d-md-table-cell d-none">Leverage</th>
                          <th className="fw-normal text-light">Coin</th>
                          <th className="fw-normal text-light text-nowrap d-lg-table-cell d-none">Entry Price</th>
                          <th className="fw-normal text-light text-nowrap">Margin</th>
                          <th className="fw-normal text-light d-lg-table-cell d-none">Qty</th>
                          <th className="fw-normal text-light d-lg-table-cell d-none">Filled Price</th>
                          <th className="fw-normal text-light d-md-table-cell d-none">Realized P&L (ROI)</th>
                          <th className="fw-normal text-light text-nowrap d-lg-table-cell d-none">Time Created</th>
                          <th className="fw-normal text-light">Status</th>
                          <th className="fw-normal text-light d-lg-none"></th>
                        </tr>
                      </thead>
                      <tbody style={{fontSize: '14px'}}>
                        {orderHistory.length > 0 && orderHistory.map((trade, index) => {
                          // PUT THE CODE HERE - inside the map function
                          const baseCoin = trade.coin_id;
                          const tradeasset = assethistory.find(item => item.coin_id == baseCoin);
                          return (
                            <FutureHistory index={index} tradeasset={tradeasset} trade={trade} />
                          );
                        })}
                        {orderHistory.length === 0 && (
                          <tr>
                            <td colSpan={5}>No order hisotry yet.</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                    )}
                    {activeTab === "copy" && (
                    <>
                      <table className="table table-borderless table-dark align-middle d-none d-lg-table">
                        <thead>
                          <tr className="fs-7">
                            <th className="fw-normal text-light">SN</th>
                            <th className="fw-normal text-light text-nowrap">Trading ID</th>
                            <th className="fw-normal text-light">Copy Trader</th>
                            <th className="fw-normal text-light">Type</th>
                            <th className="fw-normal text-light">Direction</th>
                            <th className="fw-normal text-light">Pattern</th>
                            <th className="fw-normal text-light">Leverage</th>
                            <th className="fw-normal text-light">Coin</th>
                            <th className="fw-normal text-light text-nowrap">Entry Price</th>
                            <th className="fw-normal text-light">Margin</th>
                            <th className="fw-normal text-light">Qty</th>
                            <th className="fw-normal text-light text-nowrap">Market Price</th>
                            <th className="fw-normal text-light text-nowrap">Liq. Price</th>
                            <th className="fw-normal text-light text-nowrap">Unrealized P&L(ROI)</th>
                            <th className="fw-normal text-light">TP/SL</th>
                            <th className="fw-normal text-light text-nowrap">Time Created</th>
                            <th className="fw-normal text-light">Status</th>
                          </tr>
                        </thead>
                        <tbody style={{fontSize: '14px'}}>
                          {copyTrades.length > 0 && copyTrades.map((trade, index) => {
                            // PUT THE CODE HERE - inside the map function
                            const baseCoin = trade.coin_id;
                            const tradeasset = assethistory.find(item => item.coin_id == baseCoin);
                            return (
                              <CopyFutures index={index} tradeasset={tradeasset} trade={trade} />
                            );
                          })}
                          {positionTrades.length === 0 && (
                            <tr>
                              <td colSpan={5}>No copy trades.</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                      <div className="d-block d-lg-none">
                      {positionTrades.length > 0 && positionTrades.map((trade, index) => {
                        // PUT THE CODE HERE - inside the map function
                        const baseCoin = trade.coin_id;
                        const tradeasset = assethistory.find(item => item.coin_id == baseCoin);
                        return (
                          <PositionMobile index={index} tradeasset={tradeasset} trade={trade} />
                        );
                      })}
                      <hr className="mt-2 mb-0"/>
                      </div>
                    </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}

export default Futures